/**
 * Announcements Controller
 * 
 * This controller handles the announcements dialog that is shown when the user needs to confirm an action.
*/

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'content']
  static values = { announcementUrl: String }
  
  connect() {

    // Show modal on click on announcements button
    window.addEventListener('show-announcements', this.showAnnouncementsModal.bind(this))

    const wasShown = localStorage.getItem('announcements-vpr-shown') // TODO: This key is temporary (See https://vesselindex-team.atlassian.net/browse/VI-1437)
    if (!wasShown) {
      this.showAnnouncementsModal()
      localStorage.setItem('announcements-vpr-shown', 'true')
    }
  }

  async showAnnouncementsModal() {
    await this.loadContent()
    this.dialogTarget.showModal()
  }

  async loadContent() {
    if (!this.hasContentTarget || this.contentLoaded) return

    const response = await fetch(this.announcementUrlValue, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })

    if (!response.ok) return

    this.contentTarget.innerHTML = await response.text()
    this.contentLoaded = true
  }

  close() {
    this.dialogTarget?.close()
    localStorage.setItem('announcements-vpr-dismissed', 'true')
    window.dispatchEvent(new CustomEvent('announcements-dismissed'))
  }
}